// Reset.
export const RESET = 'authorizedState/RESET';

// Ustaw wybrany element menu.
export const SET_SELECTED_MENU_ITEM = 'authorizedState/SET_SELECTED_MENU_ITEM';

// Ustaw wybrany element (ankietę lub formularz).
export const SET_SELECTED_ELEMENT = 'authorizedState/SET_SELECTED_ELEMENT';

// Ustaw kontent strony (obecnie ustawienia lub formularze)
export const SET_SELECTED_CONTENT_TYPE = 'authorizedState/SET_SELECTED_CONTENT_TYPE';

// Ustaw opcję tylko do odczytu.
export const SET_READ_ONLY_ELEMENT = 'authorizedState/SET_READ_ONLY_ELEMENT';

// Ustaw czas wygaśniecia sesji.
export const SET_EXPIRATION_DATE = 'authorizedState/SET_EXPIRATION_DATE';
